/* @generated from adl module kachemedia.specsheet.auth */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_config_db from './../../common/config/db';
import * as common_db from './../../common/db';
import * as common_strings from './../../common/strings';
import * as kachemedia_specsheet_db from './db';

export interface AuthServerConfig {
  /**
   * Aplication name
   */
  applicationName: string;
  /**
   * Environment name, e.g. dev, uat, prod
   */
  environment: string;
  /**
   * Name of the release / code version
   */
  releaseName: string;
  /**
   * Port to listen for requests
   */
  port: number;
  /**
   * Secret used to sign JWT tokens
   */
  jwtSecret: string;
  /**
   * Secret used to sign cookies
   */
  cookieSecret: string;
  /**
   * If the org identity providers change - should it restart
   */
  restartOnProvidersChange: boolean;
  /**
   * Database config
   */
  db: common_config_db.PostgreSqlConfig;
  cookie: CookieOptions;
}

export function makeAuthServerConfig(
  input: {
    applicationName: string,
    environment: string,
    releaseName: string,
    port: number,
    jwtSecret: string,
    cookieSecret: string,
    restartOnProvidersChange: boolean,
    db: common_config_db.PostgreSqlConfig,
    cookie: CookieOptions,
  }
): AuthServerConfig {
  return {
    applicationName: input.applicationName,
    environment: input.environment,
    releaseName: input.releaseName,
    port: input.port,
    jwtSecret: input.jwtSecret,
    cookieSecret: input.cookieSecret,
    restartOnProvidersChange: input.restartOnProvidersChange,
    db: input.db,
    cookie: input.cookie,
  };
}

const AuthServerConfig_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.auth","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Aplication name\n"}],"serializedName":"applicationName","default":{"kind":"nothing"},"name":"applicationName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Environment name, e.g. dev, uat, prod\n"}],"serializedName":"environment","default":{"kind":"nothing"},"name":"environment","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Name of the release / code version\n"}],"serializedName":"releaseName","default":{"kind":"nothing"},"name":"releaseName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Port to listen for requests\n"}],"serializedName":"port","default":{"kind":"nothing"},"name":"port","typeExpr":{"typeRef":{"kind":"primitive","value":"Int16"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Secret used to sign JWT tokens\n"}],"serializedName":"jwtSecret","default":{"kind":"nothing"},"name":"jwtSecret","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Secret used to sign cookies\n"}],"serializedName":"cookieSecret","default":{"kind":"nothing"},"name":"cookieSecret","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"If the org identity providers change - should it restart\n"}],"serializedName":"restartOnProvidersChange","default":{"kind":"nothing"},"name":"restartOnProvidersChange","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Database config\n"}],"serializedName":"db","default":{"kind":"nothing"},"name":"db","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.config.db","name":"PostgreSqlConfig"}},"parameters":[]}},{"annotations":[],"serializedName":"cookie","default":{"kind":"nothing"},"name":"cookie","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.auth","name":"CookieOptions"}},"parameters":[]}}]}},"name":"AuthServerConfig","version":{"kind":"nothing"}}};

export const snAuthServerConfig: ADL.ScopedName = {moduleName:"kachemedia.specsheet.auth", name:"AuthServerConfig"};

export function texprAuthServerConfig(): ADL.ATypeExpr<AuthServerConfig> {
  return {value : {typeRef : {kind: "reference", value : snAuthServerConfig}, parameters : []}};
}

export interface CookieOptions {
  secure: boolean;
}

export function makeCookieOptions(
  input: {
    secure: boolean,
  }
): CookieOptions {
  return {
    secure: input.secure,
  };
}

const CookieOptions_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.auth","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"secure","default":{"kind":"nothing"},"name":"secure","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"CookieOptions","version":{"kind":"nothing"}}};

export const snCookieOptions: ADL.ScopedName = {moduleName:"kachemedia.specsheet.auth", name:"CookieOptions"};

export function texprCookieOptions(): ADL.ATypeExpr<CookieOptions> {
  return {value : {typeRef : {kind: "reference", value : snCookieOptions}, parameters : []}};
}

export interface OrgIdentityProvider {
  /**
   * Exact org identifier
   */
  orgIdentifier: common_strings.StringNE;
  /**
   * List of javascript regexes over which other user text inputs are accepted
   */
  orgIdRegexs: string[];
  /**
   * The organisation id in specsheet database that users are joined onto.
   */
  orgId: common_db.DbKey<kachemedia_specsheet_db.Organisation>;
  /**
   * Json / union config for the implementations:
   */
  config: IdentityProviderConfig;
}

export function makeOrgIdentityProvider(
  input: {
    orgIdentifier: common_strings.StringNE,
    orgIdRegexs?: string[],
    orgId: common_db.DbKey<kachemedia_specsheet_db.Organisation>,
    config: IdentityProviderConfig,
  }
): OrgIdentityProvider {
  return {
    orgIdentifier: input.orgIdentifier,
    orgIdRegexs: input.orgIdRegexs === undefined ? [] : input.orgIdRegexs,
    orgId: input.orgId,
    config: input.config,
  };
}

const OrgIdentityProvider_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.auth","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["orgIdentifier"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Exact org identifier\n"}],"serializedName":"orgIdentifier","default":{"kind":"nothing"},"name":"orgIdentifier","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"List of javascript regexes over which other user text inputs are accepted\n"}],"serializedName":"orgIdRegexs","default":{"kind":"just","value":[]},"name":"orgIdRegexs","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The organisation id in specsheet database that users are joined onto.\n"}],"serializedName":"orgId","default":{"kind":"nothing"},"name":"orgId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.db","name":"Organisation"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Json / union config for the implementations:\n"}],"serializedName":"config","default":{"kind":"nothing"},"name":"config","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.auth","name":"IdentityProviderConfig"}},"parameters":[]}}]}},"name":"OrgIdentityProvider","version":{"kind":"nothing"}}};

export const snOrgIdentityProvider: ADL.ScopedName = {moduleName:"kachemedia.specsheet.auth", name:"OrgIdentityProvider"};

export function texprOrgIdentityProvider(): ADL.ATypeExpr<OrgIdentityProvider> {
  return {value : {typeRef : {kind: "reference", value : snOrgIdentityProvider}, parameters : []}};
}

export interface IdentityProviderConfig_AzureOidc {
  kind: 'azureOidc';
  value: AzureOidcIdentityProvider;
}
export interface IdentityProviderConfig_OktaOidc {
  kind: 'oktaOidc';
  value: OktaOidcIdentityProvider;
}

export type IdentityProviderConfig = IdentityProviderConfig_AzureOidc | IdentityProviderConfig_OktaOidc;

export interface IdentityProviderConfigOpts {
  azureOidc: AzureOidcIdentityProvider;
  oktaOidc: OktaOidcIdentityProvider;
}

export function makeIdentityProviderConfig<K extends keyof IdentityProviderConfigOpts>(kind: K, value: IdentityProviderConfigOpts[K]) { return {kind, value}; }

const IdentityProviderConfig_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.auth","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"azureOidc","default":{"kind":"nothing"},"name":"azureOidc","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.auth","name":"AzureOidcIdentityProvider"}},"parameters":[]}},{"annotations":[],"serializedName":"oktaOidc","default":{"kind":"nothing"},"name":"oktaOidc","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"kachemedia.specsheet.auth","name":"OktaOidcIdentityProvider"}},"parameters":[]}}]}},"name":"IdentityProviderConfig","version":{"kind":"nothing"}}};

export const snIdentityProviderConfig: ADL.ScopedName = {moduleName:"kachemedia.specsheet.auth", name:"IdentityProviderConfig"};

export function texprIdentityProviderConfig(): ADL.ATypeExpr<IdentityProviderConfig> {
  return {value : {typeRef : {kind: "reference", value : snIdentityProviderConfig}, parameters : []}};
}

export interface AzureOidcIdentityProvider {
  /**
   * Azure Tenant ID:
   */
  tenantId: string;
  /**
   * Azure Application (client) ID:
   */
  appClientId: string;
  /**
   * Azure Application secret (see "Certificates & secrets")
   */
  appSecretValue: string;
  redirectUrl: string;
}

export function makeAzureOidcIdentityProvider(
  input: {
    tenantId: string,
    appClientId: string,
    appSecretValue: string,
    redirectUrl: string,
  }
): AzureOidcIdentityProvider {
  return {
    tenantId: input.tenantId,
    appClientId: input.appClientId,
    appSecretValue: input.appSecretValue,
    redirectUrl: input.redirectUrl,
  };
}

const AzureOidcIdentityProvider_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.auth","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Azure Tenant ID:\n"}],"serializedName":"tenantId","default":{"kind":"nothing"},"name":"tenantId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Azure Application (client) ID:\n"}],"serializedName":"appClientId","default":{"kind":"nothing"},"name":"appClientId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Azure Application secret (see \"Certificates & secrets\")\n"}],"serializedName":"appSecretValue","default":{"kind":"nothing"},"name":"appSecretValue","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"redirectUrl","default":{"kind":"nothing"},"name":"redirectUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"AzureOidcIdentityProvider","version":{"kind":"nothing"}}};

export const snAzureOidcIdentityProvider: ADL.ScopedName = {moduleName:"kachemedia.specsheet.auth", name:"AzureOidcIdentityProvider"};

export function texprAzureOidcIdentityProvider(): ADL.ATypeExpr<AzureOidcIdentityProvider> {
  return {value : {typeRef : {kind: "reference", value : snAzureOidcIdentityProvider}, parameters : []}};
}

export interface OktaOidcIdentityProvider {
  /**
   * Okta domain
   */
  oktaDomain: string;
  /**
   * Application (client) ID:
   */
  appClientId: string;
  /**
   * Application secret
   */
  appSecretValue: string;
  redirectUrl: string;
}

export function makeOktaOidcIdentityProvider(
  input: {
    oktaDomain: string,
    appClientId: string,
    appSecretValue: string,
    redirectUrl: string,
  }
): OktaOidcIdentityProvider {
  return {
    oktaDomain: input.oktaDomain,
    appClientId: input.appClientId,
    appSecretValue: input.appSecretValue,
    redirectUrl: input.redirectUrl,
  };
}

const OktaOidcIdentityProvider_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.auth","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Okta domain\n"}],"serializedName":"oktaDomain","default":{"kind":"nothing"},"name":"oktaDomain","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Application (client) ID:\n"}],"serializedName":"appClientId","default":{"kind":"nothing"},"name":"appClientId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Application secret\n"}],"serializedName":"appSecretValue","default":{"kind":"nothing"},"name":"appSecretValue","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"redirectUrl","default":{"kind":"nothing"},"name":"redirectUrl","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"OktaOidcIdentityProvider","version":{"kind":"nothing"}}};

export const snOktaOidcIdentityProvider: ADL.ScopedName = {moduleName:"kachemedia.specsheet.auth", name:"OktaOidcIdentityProvider"};

export function texprOktaOidcIdentityProvider(): ADL.ATypeExpr<OktaOidcIdentityProvider> {
  return {value : {typeRef : {kind: "reference", value : snOktaOidcIdentityProvider}, parameters : []}};
}

/**
 * Auth session used by auth-server koa-session
 */
export interface Session {
  key: string;
  expiry: common.LocalDateTime;
  value: {}|null;
}

export function makeSession(
  input: {
    key: string,
    expiry: common.LocalDateTime,
    value: {}|null,
  }
): Session {
  return {
    key: input.key,
    expiry: input.expiry,
    value: input.value,
  };
}

const Session_AST : ADL.ScopedDecl =
  {"moduleName":"kachemedia.specsheet.auth","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withPrimaryKey":["key"]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Auth session used by auth-server koa-session\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"key","default":{"kind":"nothing"},"name":"key","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"expiry","default":{"kind":"nothing"},"name":"expiry","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDateTime"}},"parameters":[]}},{"annotations":[],"serializedName":"value","default":{"kind":"nothing"},"name":"value","typeExpr":{"typeRef":{"kind":"primitive","value":"Json"},"parameters":[]}}]}},"name":"Session","version":{"kind":"nothing"}}};

export const snSession: ADL.ScopedName = {moduleName:"kachemedia.specsheet.auth", name:"Session"};

export function texprSession(): ADL.ATypeExpr<Session> {
  return {value : {typeRef : {kind: "reference", value : snSession}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "kachemedia.specsheet.auth.AuthServerConfig" : AuthServerConfig_AST,
  "kachemedia.specsheet.auth.CookieOptions" : CookieOptions_AST,
  "kachemedia.specsheet.auth.OrgIdentityProvider" : OrgIdentityProvider_AST,
  "kachemedia.specsheet.auth.IdentityProviderConfig" : IdentityProviderConfig_AST,
  "kachemedia.specsheet.auth.AzureOidcIdentityProvider" : AzureOidcIdentityProvider_AST,
  "kachemedia.specsheet.auth.OktaOidcIdentityProvider" : OktaOidcIdentityProvider_AST,
  "kachemedia.specsheet.auth.Session" : Session_AST
};
